/**
 * Stub rating storage: in-memory + optional localStorage "already rated" flag.
 */

const STORAGE_PREFIX = 'rf-rated';
const memory: Record<string, number> = {};

function storageKey(presentationId: string): string {
  return `${STORAGE_PREFIX}-${presentationId || 'deck'}`;
}

export function recordRating(presentationId: string, stars: number): void {
  const id = presentationId || 'deck';
  memory[id] = Math.min(5, Math.max(1, stars));
  try {
    localStorage.setItem(storageKey(presentationId), '1');
  } catch {
    // ignore
  }
}

export function getMyRating(presentationId: string): Promise<number | null> {
  const id = presentationId || 'deck';
  return Promise.resolve(memory[id] ?? null);
}

export function hasRated(presentationId: string): boolean {
  try {
    return localStorage.getItem(storageKey(presentationId)) === '1';
  } catch {
    return false;
  }
}
